module.exports = __webpack_public_path__ + "04_long_brown.c23e5872.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer5/04_long_brown.png
// module id = o7B2
// module chunks = 0